import { type ReactElement } from "react";
import { Input } from "antd";
import { CloseCircleOutlined, SearchOutlined } from "@ant-design/icons";
import "./search.less";
import { formatTranslation } from "../../utils/translationUtils";
import { useTranslation } from "react-i18next";

export const Search = ({
  searchText,
  setSearchTexts,
  className,
}: {
  searchText: string;
  setSearchTexts: (text: string) => void;
  className?: string;
}): ReactElement => {
  const { t } = useTranslation();
  return (
    <Input
      className={` ${className ?? " "} search-input `}
      data-testid="search-input"
      value={searchText}
      prefix={<SearchOutlined className="site-form-item-icon" />}
      suffix={
        searchText && (
          <button
            type="button"
            className="suffix-icon"
            onClick={() => {
              setSearchTexts("");
            }}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                setSearchTexts("");
              }
            }}
          >
            <CloseCircleOutlined data-testid="clear-icon" />
          </button>
        )
      }
      onChange={(e) => {
        setSearchTexts(e.target.value);
      }}
      placeholder={formatTranslation(t("configure.search.button.placeholder"))}
    />
  );
};
